import { render, staticRenderFns } from "./AlarmTypeCard.vue?vue&type=template&id=07b37d9f&scoped=true&"
import script from "./AlarmTypeCard.vue?vue&type=script&lang=js&"
export * from "./AlarmTypeCard.vue?vue&type=script&lang=js&"
import style0 from "./AlarmTypeCard.vue?vue&type=style&index=0&id=07b37d9f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b37d9f",
  null
  
)

export default component.exports